import React from 'react'
import createClass from 'create-react-class'
import { Table } from 'react-bootstrap'

import { ErrorMessagesAlert } from './components/error-alert'
import { Loading } from './components/loading'

import _ from 'lodash'
import i18n from 'live/services/i18n'
import moment from 'moment'

import ExtensionUi from 'live/components/extensions/ui/base'
import CodeSyntax from 'live/components/code/ui/syntax'

import ActionsFactory from '../lib/queries/actions'
import StoreFactory from '../lib/queries/store'
import StoreBasedMixinFactory from 'live/components/mixins/store-based'
import ObjectInitializerFactory from 'live/components/forms/mixins/object-initializer'

const Actions = ActionsFactory('plugin-mongodb/queries')
const Store = StoreFactory('plugin-mongodb/queries', Actions)
const StoreBasedMixin = StoreBasedMixinFactory(Store)
const ObjectInitializerMixin = ObjectInitializerFactory('/rest/extension')

const QueryStatus = ({ query }) => {
    const countTime = query.countTime
    const firstTime = query.firstTime
    const lastTime = query.lastTime
    const queryTime = (lastTime / 1000).toFixed(2)

    const sliderStyle = {
        width: ((firstTime - countTime) / lastTime) * 100,
        left: (countTime / lastTime) * 100
    }

    return (
        <div className="query-status">
            {query.cancelled ? (
                <p>{i18n('cancelled')}</p>
            ) : query.iterations < query.count ? (
                <p className="query-status-success">{i18n('running')}</p>
            ) : (
                <p>{i18n('completed')}</p>
            )}
            <span className="query-status-chart">
                <span className="slider" style={sliderStyle}></span>
            </span>
            {typeof lastTime == 'undefined' ? (
                <span className="query-status-time query-status-time-loading"></span>
            ) : lastTime < 10000 ? (
                <span className="query-status-time">{queryTime}s</span>
            ) : lastTime > 10000 && lastTime < 30000 ? (
                <span className="query-status-time query-status-warning">{queryTime}s</span>
            ) : (
                <span className="query-status-time query-status-danger">{queryTime}s</span>
            )}
        </div>
    )
}

const Queries = createClass({
    mixins: [StoreBasedMixin, ObjectInitializerMixin],
    getInitialState() {
        return {
            expanded: {}
        }
    },

    _onAfterFetch() {
        const instance = this.state.object
        const qualifier = instance.qualifier

        Actions.getQueries(qualifier)
    },

    checkNode(target) {
        const allowedNodes = ['DIV', 'TD', 'I']

        return allowedNodes.indexOf(target.nodeName) != -1
    },

    expandOrCollapse(state, queryInfo, index, e) {
        if (!this.checkNode(e.target)) return false

        const expanded = _.clone(state.expanded)
        expanded[index] = !expanded[index]
        this.setState({ expanded })
    },

    explainQuery(state, queryInfo, index) {
        const instance = this.state.object
        const qualifier = instance.qualifier

        Actions.explainQuery(qualifier, queryInfo, index)
    },

    clearError() {
        const currentState = { ...this.state }
        if (currentState.object?.status?.messages) {
            currentState.object.status.messages = null
        }
        currentState.httpFailure = null
        currentState.httpDetailedError = null
        currentState.commandFailure = null

        this.setState(currentState)
    },

    render() {
        const state = this.state
        const instance = state.object
        const config = instance.config

        const queries = state.queries
        const expanded = state.expanded
        const loading = state.loadingQueries
        const loadingQuery = state.loadingQuery
        const startedQuery = state.startedQuery
        const httpFailure = state.httpFailure
        const httpDetailedError = state.httpDetailedError
        const commandFailure = state.commandFailure
        const dbname = config && config.dbName ? config.dbName : ''
        const addresses = config && config.addresses ? config.addresses.join(', ') : ''
        const headerSubtitle = `${i18n('Database')}: ${dbname} | ${i18n('Addresses')}: ${addresses}`

        const lastElementStatusMessage = instance?.status?.messages ? instance.status.messages[0] : null
        const queryError = (httpFailure && httpFailure !== '') || lastElementStatusMessage

        return (
            <ExtensionUi
                className="queries"
                {...this.props}
                {...{ instance }}
                uiCfg={{ headerSubtitle }}
                noFetch={true}
            >
                {loading ? (
                    <Loading className="loading" />
                ) : (
                    <>
                        <div className="queries-header">
                            {queryError && (
                                <ErrorMessagesAlert
                                    title={commandFailure}
                                    httpFailure={httpFailure}
                                    serverSideErrorMessage={httpDetailedError || lastElementStatusMessage}
                                    invalidElement={!!lastElementStatusMessage}
                                    onClose={this.clearError}
                                />
                            )}
                        </div>

                        <div className="queries-body">
                            {!queries || !queries.length ? (
                                <div className="is-empty">{i18n('No slow, running or completed queries')}</div>
                            ) : (
                                <Table className="queries-list table-fixed table-hover">
                                    <thead>
                                        <tr>
                                            <th className="col-md-10">{i18n('Query')}</th>
                                            <th className="col-md-2">{i18n('Status')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(
                                            queries,
                                            function (query, i) {
                                                const collection = query.info.collection
                                                const queryDetail = query.info.query
                                                const sort = query.info.sort
                                                const explain = query.explain
                                                const isExpanded = expanded[i]
                                                const isLoading = loadingQuery[i] ? loadingQuery[i] : false
                                                const isStarted = startedQuery[i] ? startedQuery[i] : false
                                                const icon = isExpanded ? 'minus' : 'plus'
                                                const rowActive = isExpanded ? 'query-active' : ''

                                                return (
                                                    <tr
                                                        key={i}
                                                        className={rowActive}
                                                        onClick={this.expandOrCollapse.bind(this, state, query.info, i)}
                                                    >
                                                        <td className="col-md-10">
                                                            <div className="query-info">
                                                                <span>
                                                                    <span className="key">collection:</span>{' '}
                                                                    <CodeSyntax value={collection} inline={true} />,
                                                                </span>{' '}
                                                                <br />
                                                                <span>
                                                                    <span className="key">query:</span>{' '}
                                                                    <CodeSyntax value={queryDetail} inline={true} />,
                                                                    <span className="key"> sort:</span>{' '}
                                                                    <CodeSyntax value={sort} inline={true} />
                                                                </span>{' '}
                                                                <br />
                                                                {isExpanded ? (
                                                                    <span className="query-info-detail">
                                                                        <span className="key">startTime:</span>{' '}
                                                                        <span className="number">
                                                                            {moment(query.startTime).format(
                                                                                'DD/MM/YYYY HH:mm:ss'
                                                                            )}
                                                                        </span>
                                                                        ,<span className="key"> count:</span>{' '}
                                                                        <span className="number">{query.count}</span>,
                                                                        <span className="key"> iterations:</span>{' '}
                                                                        <span className="number">
                                                                            {query.iterations}
                                                                        </span>
                                                                        ,<span className="key"> countTime:</span>{' '}
                                                                        <span className="number">
                                                                            {query.countTime}
                                                                        </span>
                                                                        ,<span className="key"> firstTime:</span>{' '}
                                                                        <span className="number">
                                                                            {query.firstTime}
                                                                        </span>
                                                                        ,<span className="key"> lastTime:</span>{' '}
                                                                        <span className="number">{query.lastTime}</span>
                                                                        ,<span className="key"> cancelled:</span>{' '}
                                                                        <span className="boolean">
                                                                            {query.cancelled.toString()}
                                                                        </span>
                                                                        <br />
                                                                        {!isStarted ? (
                                                                            <a
                                                                                className="btn btn-primary explain-status"
                                                                                onClick={this.explainQuery.bind(
                                                                                    this,
                                                                                    state,
                                                                                    query.info,
                                                                                    i
                                                                                )}
                                                                            >
                                                                                {i18n('Explain query')}
                                                                            </a>
                                                                        ) : null}
                                                                    </span>
                                                                ) : isStarted && typeof explain != 'undefined' ? (
                                                                    <p className="explain-status query-status-success">
                                                                        <i className="fa fa-check fa-fw"></i>{' '}
                                                                        {i18n('Explained query available')}
                                                                    </p>
                                                                ) : null}
                                                                {isStarted && isLoading ? (
                                                                    <span className="btn btn-processing explain-status">
                                                                        <i className="fa fa-spinner fa-spin fa-fw"></i>{' '}
                                                                        {i18n('Processing. It could take some time.')}
                                                                    </span>
                                                                ) : null}
                                                            </div>

                                                            {isExpanded && typeof explain != 'undefined' ? (
                                                                <CodeSyntax
                                                                    value={explain}
                                                                    title={i18n('Explain Results')}
                                                                    indent={true}
                                                                />
                                                            ) : null}
                                                        </td>
                                                        <td className="col-md-2">
                                                            <QueryStatus {...{ query }} />
                                                            <i className={`btn-expanded fa fa-${icon}`}></i>
                                                        </td>
                                                    </tr>
                                                )
                                            }.bind(this)
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </div>
                    </>
                )}
            </ExtensionUi>
        )
    }
})

export default Queries
